module.exports = __webpack_public_path__ + "img/app_icon_default.05a9990a.png";